import React from 'react'
import styles from './Badge.module.scss'

type Variant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'ghost'

interface BadgeProps {
  children: React.ReactNode
  variant?: Variant
  className?: never
}

const variantMap: Record<Variant, string> = {
  default: styles.default, success: styles.success, warning: styles.warning,
  error: styles.error, info: styles.info, ghost: styles.ghost,
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default' }) => (
  <span className={[styles.badge, variantMap[variant]].join(' ')}>{children}</span>
)
